module.exports = __webpack_public_path__ + "img/check_green.7af71a4b.svg";